<template>
	<div class="structure">
		<div class="">
			<div class="blue-title scroll-item">{{ campainName }}</div>
			<div class="space">
				<span>状态{{ status | statusFilter }};</span><span>预算{{ amountMicros }};</span>
				{{ biddingStrategyType }}
			</div>
			<div class="space">定位：{{ location | arrFilter }}</div>
			<div class="space">排除：{{ exclude | arrFilter }}</div>
		</div>
		<div v-for="(item, index) in adGroupVos" :key="index" class="adGroupVos">
			<div class="space groupTitle scroll-item">
				广告组：{{ item.adGroupName }}（ 关键词、广告标题、广告说明均取自“{{
					item.campaignName
				}}”的推广物料）
			</div>
			<div class="space">
				<span>状态{{ item.status | statusFilter }};</span>出价 {{ item.cpcBidMicros }}
			</div>
			<el-row :gutter="20">
				<el-col :span="12">
					<div class="colDiv">
						<div class="top-part">
							<div class="top-div">
								<div class="img">
									<img class="img-box" :src="item.imgPath" v-if="item.imgPath" />
								</div>
								<div class="right-text">
									<p class="prdTitle">{{ item.adGroupName }}</p>
									<p class="finalUrls" @click="open(item.adGroupAdsVos[0].finalUrls)">
										{{ item.adGroupAdsVos[0].finalUrls }}
									</p>
								</div>
							</div>
						</div>
						<div class="bottom-part">
							<div @click="dialogClick('1', item)">广告标题</div>
							<div @click="dialogClick('2', item)">广告说明语</div>
							<div @click="dialogClick('3', item)">关键词</div>
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="colDiv right-div">
						<div class="text">广告 · {{ item.adGroupAdsVos[0].finalUrls }}</div>
						<div class="title">
							{{ item.adGroupAdsVos[0].headlines.toString() }}
						</div>
						<div class="text">
							{{ item.adGroupAdsVos[0].descriptions.toString() }}
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="40%"
			custom-class="tabDialog"
		>
			<el-tabs v-model="activeName">
				<el-tab-pane label="广告标题" name="1">
					<div class="srcolldiv">
						<div v-for="(item, index) in productTitle" :key="index" class="line">{{ item }}</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="广告说明语" name="2">
					<div class="srcolldiv">
						<div v-for="(item, index) in productExplain" :key="index" class="line">
							{{ item }}
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="关键词" name="3">
					<el-row class="keywordTitle">
						<el-col :span="12">关键词</el-col>
						<el-col :span="6">平均每月搜索量</el-col>
						<el-col :span="6">竞争程度</el-col>
					</el-row>
					<div class="srcolldiv">
						<el-row v-for="(item, index) in keyWords" :key="index" class="line">
							<el-col :span="12"
								><div :class="[{ linkHover: item.keywordLink }, 'link-box']">
									<ig-icon
										v-if="item.keywordLink"
										name="lianjie"
										class="keywordLink"
										@click.native="open(item.keywordLink)"
									></ig-icon>
									<div>
										{{ item.keyword }}
									</div>
								</div>
							</el-col>
							<el-col :span="6"
								><div>{{ item.searchNum || '-' }}</div></el-col
							>
							<el-col :span="6"
								><div>{{ item.compete || '-' }}</div></el-col
							>
						</el-row>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: [
		'campainName',
		'location',
		'biddingStrategyType',
		'amountMicros',
		'exclude',
		'status',
		'adGroupVos',
	],
	data() {
		return {
			dialogTitle: '',
			productTitle: '',
			productExplain: '',
			keyWords: '',
			dialogVisible: false,
			activeName: '1',
		};
	},
	filters: {
		statusFilter(val) {
			return val == 0 ? '关闭' : '启用';
		},
		arrFilter(val) {
			return val && val.length ? val.toString() : '-';
		},
	},
	components: {},

	computed: {},

	methods: {
		dialogClick(type, item) {
			this.dialogTitle = item.adGroupName;
			this.productTitle = item.adGroupAdsVos[0].headlines;
			this.productExplain = item.adGroupAdsVos[0].descriptions;
			this.keyWords = item.keyWords;
			this.activeName = type;
			this.dialogVisible = true;
		},
		open(url) {
			console.log('url', url);
			window.open(url);
		},
	},
};
</script>

<style lang="scss" scoped>
.structure {
	font-size: 14px;
	padding: 20px 30px;
	font-weight: 400;
	color: #333333;
	.blue-title {
		border-left: 5px #3da1ff solid;
		padding: 0px 10px;
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 20px;
	}
	.space {
		padding: 5px 0px;
	}
	.adGroupVos {
		background: #f2f2f2;

		border-radius: 2px;
		margin: 20px 0px;
		padding: 20px 20px 30px 20px;
		.groupTitle {
			font-weight: 600;
		}
		.colDiv {
			margin-top: 20px;
			background: #ffffff;
			box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.1);
			border-radius: 2px;
			.top-part {
				padding: 20px;
			}
			.top-div {
				display: flex;
				position: relative;

				.img {
					width: 80px;
					height: 80px;
					border-radius: 2px;
					margin-right: 15px;
				}
				.img-box {
					width: 80px;
					height: 80px;
					border-radius: 2px;
					margin-right: 15px;
				}
				.right-text {
					display: inline-block;
					position: relative;
					flex: 1;
					color: #1a0dab;

					.prdTitle {
						font-size: 18px;
						font-weight: 500;
						line-height: 30px;
						margin-bottom: 10px;
					}
					.finalUrls {
						width: 100%;
						height: 50px;
						display: inline-block;
						word-break: break-all;
						cursor: pointer;
					}
				}
			}
			.bottom-part {
				border-top: 1px #efefef solid;
				display: flex;
				height: 52px;
				justify-content: space-around;
				// align-items: center;
				div {
					cursor: pointer;
					line-height: 52px;
					text-align: center;
					flex: 1;
					height: 52px;
					border-right: 1px #efefef solid;
					font-weight: 500;
					color: #3da1ff;
					font-size: 16px;
				}
			}
		}
		.right-div {
			padding: 20px;
			.title {
				font-weight: 500;
				color: #1a0dab;
				font-size: 18px;
				margin: 5px 0px;
			}
			.text {
				font-weight: 400;
				color: #999999;
				display: inline-block;
				word-break: break-all;
			}
		}
	}
	::v-deep  .tabDialog {
		.el-dialog__body {
			padding: 10px 30px 50px 30px !important;
		}
	}
	.line {
		padding: 15px 0px;
		text-align: left;
		border-bottom: 1px #e8e8e8 solid;
	}
	.srcolldiv {
		max-height: 350px;
		overflow-x: hidden;
		overflow-y: scroll;
	}
	/*滚动条样式*/
	.srcolldiv::-webkit-scrollbar {
		position: relative;
		width: 6px;
	}
	.srcolldiv::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
		background: rgba(163, 155, 155, 0.2);
	}
	.srcolldiv::-webkit-scrollbar-track {
		/* box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3); */
		border-radius: 0;
		/* background: rgba(193, 185, 185, 0.1); */
	}
	.keywordTitle {
		background: #eaeaea;
		border-radius: 2px;
		font-size: 14px;
		font-weight: 500;
		color: #333333;
		padding: 10px;
	}
	.keywordLink {
		color: #3da1ff;
		margin-right: 5px;
		cursor: pointer;
	}
	.link-box {
		display: flex;
		padding-left: 10px;
	}
	.linkHover:hover {
		color: #3da1ff;
	}
}
</style>
